import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BlogDetailsMain from './BlogDetailsMain';
// import Breadcrumb from '../../components/Breadcrumb/BlogBreadcrumbs';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTop from '../../components/ScrollTop';
import posts from '../../data/Posts.json';

import Logo from '../../assets/images/logos/logo2.png';
import FooterTwo from '../../components/Footer/FooterTwo';
import BlogService from '../../services/blog.service';

const BlogDetails = () => {
    const [blogDetail,setBlogDetail]=React.useState({});
    const [categoryList,setCategoryList]=React.useState([]);
    const {slug}=useParams();
     
    
    // const post = posts.find((b) => b.id === Number(1));


    React.useEffect(()=>{

        //Fetching Blog Details
     BlogService.detail(slug)
     .then(res=>setBlogDetail(res?.data))
     .catch(err=>console.log(err));

    },[slug]);

    React.useEffect(()=>{
        BlogService.category()
        .then(res=>setCategoryList(res?.data))
        .catch(err=>console.log(err));
    },[]);

    return (
        <body className="course-single blog-post-page blog-post-single-page">
            <Header
                parentMenu='blog'
                menuCategoryEnable='enable'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
            />

            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                    <Breadcrumb
                    pageTitle={"Blogs Detail"}
                        // postTitle={post.title}
                        // postImg={post.image}
                        // postBannerImg={post.bannerImg}
                        // postCategory={post.category}
                        // postAuthor={post.author}
                        // postAuthorImg={post.authorImg}
                        // postPublishedDate={post.publishedDate}
                        // postTotalView={post.totalView}
                    />

                    {/* Blog Main */}
                    <BlogDetailsMain 
                        postTitle={blogDetail?.title}
                        postImg={blogDetail?.featureImgUrl}
                        description={blogDetail?.description}
                        // postBannerImg={post.bannerImg}
                        // postAuthor={post.author}
                        // postAuthorImg={post.authorImg}
                        postPublishedDate={blogDetail?.date?.split("T")[0]}
                        // postTotalView={post.totalView}
                        relatedBlogs={blogDetail?.relatedBlogs}
                        popularBlogs={blogDetail?.popularBlogs}
                        popularTags={blogDetail?.popularTags}
                        authorDetails={blogDetail?.authorDetails}
                        categoryList={categoryList}
                    />
                    {/* Blog Main End */}

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            {/* <Footer /> */}
            <FooterTwo/>

        </body>
    );
}


export default BlogDetails;

